import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as intelligentbigdataActions } from "../../../../../../../redux/modules/intelligentbigdata";
import CommonTip from "../../../../../../../components/CommonTip";
import "./style.css";
import "../../../../../../../index.css";
let levelMarkArray = [];
let tagMarkArray = [];
let propertyMarkArray = [];
let provinceMarkArray = [];
let limitMarkArray = [0, 0, 0, 0];
let subjectMarkArray = [];
// 保存选中按钮的id
let levelData = [];
let tagData = [];
let propertyData = [];
let provinceData = [];
let limitData = [0];
let subjectData = [];
class IntelligentSchoolFilterGroup extends Component {
  constructor(props) {
    super(props);
    this.state = { msg: "" };
  }
  componentDidMount() {
    limitMarkArray = this.props.markArray.limitMarkArray;
    levelMarkArray = this.props.markArray.levelMarkArray;
    tagMarkArray = this.props.markArray.tagMarkArray;
    propertyMarkArray = this.props.markArray.propertyMarkArray;
    provinceMarkArray = this.props.markArray.provinceMarkArray;
    subjectMarkArray = this.props.markArray.subjectMarkArray;
    // 调用父组件方法把当前实例传给父组件
    this.props.onRef("schoolFilterGroup", this);
  }
  render() {
    const { name, filters } = this.props;
    const {
      limitMarkArray,
      levelMarkArray,
      tagMarkArray,
      propertyMarkArray,
      provinceMarkArray,
      subjectMarkArray,
    } = this.props.markArray;
    return (
      <div
        className={
          name === "分数位次"
            ? "intelligent_filter_gbox major_top_6"
            : "intelligent_filter_gbox major_top_25"
        }
      >
        <div>
          <div className="fl">{name === "高校层次" ? "培养层次" : name}</div>
          {name === "选科限制" ? (
            <div
              onClick={this.handOpenCommonTip}
              style={{
                fontSize: "12px",
                marginLeft: "8px",
                paddingTop: "3px",
                color: "#b1b1b1",
              }}
              className="fl"
            >
              单选
              <img
                style={{
                  width: "13px",
                  position: "relative",
                  top: "2px",
                  marginLeft: "4px",
                }}
                alt=""
                src={require("../../../../../../../images/intelligent/question.png")}
              ></img>
            </div>
          ) : (
            ""
          )}

          <div className="clear"></div>
        </div>

        <div className="intelligent_filter_gbox_f">
          {name === "分数位次" ? (
            <div>
              <div>
                <div className="fl font_size_13 color_5d5d5d">最低分</div>
                <div className="fl intelligent_filter_gbox_f_input">
                  <input
                    value={this.props.schoolFilter.rowScore}
                    onChange={this.handleMinScoreChange}
                    type="text"
                  ></input>{" "}
                  —{" "}
                  <input
                    value={this.props.schoolFilter.highScore}
                    onChange={this.handleMaxScoreChange}
                    type="text"
                  ></input>
                </div>
                <div className="clear"></div>
              </div>
              <div className="major_top_20">
                <div className="fl font_size_13 color_5d5d5d">位次号</div>
                <div className="fl intelligent_filter_gbox_f_input">
                  <input
                    value={this.props.schoolFilter.minRank}
                    onChange={this.handleMinRankChange}
                    type="text"
                  ></input>{" "}
                  —{" "}
                  <input
                    value={this.props.schoolFilter.maxRank}
                    onChange={this.handleMaxRankChange}
                    type="text"
                  ></input>
                </div>
                <div className="clear"></div>
              </div>
            </div>
          ) : (
            ""
          )}
          {filters.map((item, index) => {
            if (name === "选科要求（不超过3科）") {
              return (
                <div
                  onClick={() => this.handleSelectFilter(index, item.id, name)}
                  style={{
                    backgroundColor: subjectMarkArray[index] ? "#ffeae0" : "",
                    color: subjectMarkArray[index] ? "#fb6620" : "",
                  }}
                  className={
                    index % 4 === false
                      ? "fl intelligent_filter_gbox_s_fd major_left_0"
                      : "fl intelligent_filter_gbox_s_fd major_left_5"
                  }
                  key={index}
                >
                  {item.abbreviation}
                  <img
                    style={{
                      display: subjectMarkArray[index] ? "block" : "none",
                      width: 10,
                      height: 10,
                    }}
                    className="intelligent_filter_gbox_fd_img"
                    alt=""
                    src={require("../../../../../../../images/search/search_0.png")}
                  ></img>
                </div>
              );
            }
            if (name === "选科限制") {
              return (
                <div
                  onClick={() => this.handleSelectFilter(index, item.id, name)}
                  style={{
                    marginTop: index > 3 ? 5 : false,
                    backgroundColor: limitMarkArray[index] ? "#ffeae0" : "",
                    color: limitMarkArray[index] ? "#fb6620" : "",
                  }}
                  className={
                    index % 4 === false
                      ? "fl intelligent_filter_gbox_fd major_left_0"
                      : "fl intelligent_filter_gbox_fd major_left_5"
                  }
                  key={index}
                >
                  {item.name}
                  <img
                    style={{
                      display: limitMarkArray[index] ? "block" : "none",
                    }}
                    className="intelligent_filter_gbox_fd_img"
                    alt=""
                    src={require("../../../../../../../images/search/search_0.png")}
                  ></img>
                </div>
              );
            }
            if (name === "高校层次") {
              return (
                <div
                  onClick={() => this.handleSelectFilter(index, item.id, name)}
                  style={{
                    marginTop: index > 3 ? 5 : false,
                    backgroundColor: levelMarkArray[index] ? "#ffeae0" : "",
                    color: levelMarkArray[index] ? "#fb6620" : "",
                  }}
                  className={
                    index % 4 === false
                      ? "fl intelligent_filter_gbox_fd major_left_0"
                      : "fl intelligent_filter_gbox_fd major_left_5"
                  }
                  key={index}
                >
                  {item.name}
                  <img
                    style={{
                      display: levelMarkArray[index] ? "block" : "none",
                    }}
                    className="intelligent_filter_gbox_fd_img"
                    alt=""
                    src={require("../../../../../../../images/search/search_0.png")}
                  ></img>
                </div>
              );
            }
            if (name === "高校标签") {
              return (
                <div
                  onClick={() => this.handleSelectFilter(index, item.id, name)}
                  style={{
                    marginTop: index > 3 ? 5 : false,
                    backgroundColor: tagMarkArray[index] ? "#ffeae0" : "",
                    color: tagMarkArray[index] ? "#fb6620" : "",
                  }}
                  className={
                    index % 4 === false
                      ? "fl intelligent_filter_gbox_fd major_left_0"
                      : "fl intelligent_filter_gbox_fd major_left_5"
                  }
                  key={index}
                >
                  {item.name}
                  <img
                    style={{
                      display: tagMarkArray[index] ? "block" : "none",
                    }}
                    className="intelligent_filter_gbox_fd_img"
                    alt=""
                    src={require("../../../../../../../images/search/search_0.png")}
                  ></img>
                </div>
              );
            }
            if (name === "办学性质") {
              return (
                <div
                  onClick={() => this.handleSelectFilter(index, item.id, name)}
                  style={{
                    marginTop: index > 3 ? 5 : false,
                    backgroundColor: propertyMarkArray[index] ? "#ffeae0" : "",
                    color: propertyMarkArray[index] ? "#fb6620" : "",
                  }}
                  className={
                    index % 4 === false
                      ? "fl intelligent_filter_gbox_fd major_left_0"
                      : "fl intelligent_filter_gbox_fd major_left_5"
                  }
                  key={index}
                >
                  {item.name}
                  <img
                    style={{
                      display: propertyMarkArray[index] ? "block" : "none",
                    }}
                    className="intelligent_filter_gbox_fd_img"
                    alt=""
                    src={require("../../../../../../../images/search/search_0.png")}
                  ></img>
                </div>
              );
            }
            if (name === "地区") {
              return (
                <div
                  onClick={() => this.handleSelectFilter(index, item.id, name)}
                  style={{
                    marginTop: index > 3 ? 5 : false,
                    backgroundColor: provinceMarkArray[index] ? "#ffeae0" : "",
                    color: provinceMarkArray[index] ? "#fb6620" : "",
                  }}
                  className={
                    index % 4 === false
                      ? "fl intelligent_filter_gbox_fd major_left_0"
                      : "fl intelligent_filter_gbox_fd major_left_5"
                  }
                  key={index}
                >
                  {item.name}
                  <img
                    style={{
                      display: provinceMarkArray[index] ? "block" : "none",
                    }}
                    className="intelligent_filter_gbox_fd_img"
                    alt=""
                    src={require("../../../../../../../images/search/search_0.png")}
                  ></img>
                </div>
              );
            }
            return <div></div>;
          })}
          <div className="clear"></div>
        </div>
        {this.state.msg ? (
          <CommonTip
            handCloseCommonTip={this.handCloseCommonTip}
            msg={this.state.msg}
          ></CommonTip>
        ) : null}
      </div>
    );
  }
  /**
   * 打开提示
   */
  handOpenCommonTip = () => {
    this.setState({
      msg: "举例说明：<br><br>限1科即一科必选：物理 <br>限2科即二科必选：物理&化学<br> 限3科即三科必选：物理&化学&生物 <br><br>其他即二三科中的任意一科或不限科目：物理/化学，物理/历史/地理，不限科目。",
    });
  };
  /**
   * 关闭提示
   */
  handCloseCommonTip = () => {
    this.setState({
      msg: "",
    });
  };
  /**
   * 最高分数改变
   */
  handleMaxScoreChange = (e) => {
    const { dispatch } = this.props;
    let maxScore = e.target.value.replace(/\D/g, "");
    maxScore = maxScore === "" ? "" : parseInt(maxScore.replace(/\D/g, ""), 0);
    dispatch(intelligentbigdataActions.setHighScore(maxScore));
  };
  /**
   * 最低分数改变
   */
  handleMinScoreChange = (e) => {
    const { dispatch } = this.props;
    let minScore = e.target.value.replace(/\D/g, "");
    minScore = minScore === "" ? "" : parseInt(minScore.replace(/\D/g, ""), 0);
    dispatch(intelligentbigdataActions.setRowScore(minScore));
  };

  /**
   * 最高位次改变
   */
  handleMaxRankChange = (e) => {
    const { dispatch } = this.props;
    let maxRank = e.target.value.replace(/\D/g, "");
    maxRank = maxRank === "" ? "" : parseInt(maxRank.replace(/\D/g, ""), 0);
    dispatch(intelligentbigdataActions.setMaxRank(maxRank));
  };
  /**
   * 最低位次改变
   */
  handleMinRankChange = (e) => {
    const { dispatch } = this.props;
    let minRank = e.target.value.replace(/\D/g, "");
    minRank = minRank === "" ? "" : parseInt(minRank.replace(/\D/g, ""), 0);
    dispatch(intelligentbigdataActions.setMinRank(minRank));
  };

  /**
   *设置默认的选科限制
   */
  handleSetNormalLimit = () => {
    const { dispatch } = this.props;
    if (
      this.props.schoolFilter.subjectFilterId.length < 1 &&
      limitMarkArray[0] === 0 &&
      limitMarkArray[1] === 0 &&
      limitMarkArray[2] === 0 &&
      limitMarkArray[3] === 0
    ) {
      limitMarkArray[0] = 0;
      limitMarkArray[1] = 0;
      limitMarkArray[2] = 0;
      limitMarkArray[3] = 1;
      dispatch(intelligentbigdataActions.setLimitMarkArray(limitMarkArray));
      limitData[0] = 0;
      dispatch(intelligentbigdataActions.setLimitFilterId(limitData));
    }
  };

  /**
   * 选中过滤条件
   */
  handleSelectFilter = (index, id, name) => {
    var arr;
    const { dispatch } = this.props;
    switch (name) {
      case "选科要求（不超过3科）": {
        this.handleSetNormalLimit();
        if (
          this.props.schoolFilter.subjectFilterId.length < 3 &&
          subjectMarkArray[index] === 0
        ) {
          subjectMarkArray[index] = subjectMarkArray[index] === 1 ? 0 : 1;
          dispatch(
            intelligentbigdataActions.setSubjectMarkArray(subjectMarkArray)
          );
          arr = this.handleArrary(id, subjectMarkArray[index], subjectData);
          dispatch(intelligentbigdataActions.setSubjectFilterId(arr));
        } else if (
          this.props.schoolFilter.subjectFilterId.length >= 1 &&
          subjectMarkArray[index] === 1
        ) {
          subjectMarkArray[index] = subjectMarkArray[index] === 1 ? 0 : 1;
          dispatch(
            intelligentbigdataActions.setSubjectMarkArray(subjectMarkArray)
          );
          arr = this.handleArrary(id, subjectMarkArray[index], subjectData);
          dispatch(intelligentbigdataActions.setSubjectFilterId(arr));
        }
        break;
      }
      case "选科限制": {
        limitMarkArray[0] = 0;
        limitMarkArray[1] = 0;
        limitMarkArray[2] = 0;
        limitMarkArray[3] = 0;
        limitMarkArray[index] = limitMarkArray[index] === 1 ? 0 : 1;
        dispatch(intelligentbigdataActions.setLimitMarkArray(limitMarkArray));
        //arr = this.handleArrary(id, limitMarkArray[index], limitData);
        limitData[0] = id;
        dispatch(intelligentbigdataActions.setLimitFilterId(limitData));
        break;
      }
      case "高校层次": {
        levelMarkArray[index] = levelMarkArray[index] === 1 ? 0 : 1;
        dispatch(intelligentbigdataActions.setLevelMarkArray(levelMarkArray));
        arr = this.handleArrary(id, levelMarkArray[index], levelData);
        dispatch(intelligentbigdataActions.setLevelFilterId(arr));
        break;
      }
      case "高校标签": {
        tagMarkArray[index] = tagMarkArray[index] === 1 ? 0 : 1;
        dispatch(intelligentbigdataActions.setTagMarkArray(tagMarkArray));
        arr = this.handleArrary(id, tagMarkArray[index], tagData);
        dispatch(intelligentbigdataActions.setTagFilterId(arr));
        break;
      }
      case "办学性质": {
        propertyMarkArray[index] = propertyMarkArray[index] === 1 ? 0 : 1;
        dispatch(
          intelligentbigdataActions.setPropertyMarkArray(propertyMarkArray)
        );
        arr = this.handleArrary(id, propertyMarkArray[index], propertyData);
        dispatch(intelligentbigdataActions.setPropertyFilterId(arr));
        break;
      }
      case "地区": {
        provinceMarkArray[index] = provinceMarkArray[index] === 1 ? 0 : 1;
        dispatch(
          intelligentbigdataActions.setProvinceMarkArray(provinceMarkArray)
        );
        arr = this.handleArrary(id, provinceMarkArray[index], provinceData);
        dispatch(intelligentbigdataActions.setProvinceFilterId(arr));
        break;
      }
      default: {
        break;
      }
    }
  };
  /**
   * 处理数组
   */
  handleArrary = (id, status, data) => {
    if (status === 1) {
      data.push(id);
    } else {
      this.handleRemove(id, data);
    }
    return data;
  };

  /**
   * 删除指定数组元素
   */
  handleRemove = (val, data) => {
    var index = this.getIndexOf(val, data);
    if (index > -1) {
      data.splice(index, 1);
    }
  };
  //获取元素在数组的下标
  getIndexOf = function (val, data) {
    for (var i = 0; i < data.length; i++) {
      if (data[i] === val) {
        return i;
      }
    }
    return -1;
  };
  /**
   * 重置ui状态以及过滤条件
   */
  resetUIState = () => {
    const { dispatch } = this.props;
    dispatch(intelligentbigdataActions.setHighScore(""));
    dispatch(intelligentbigdataActions.setRowScore(""));
    dispatch(intelligentbigdataActions.setMaxRank(""));
    dispatch(intelligentbigdataActions.setMinRank(""));

    for (let i = 0; i < subjectMarkArray.length; i++) {
      subjectMarkArray[i] = 0;
    }
    dispatch(intelligentbigdataActions.setSubjectMarkArray(subjectMarkArray));
    dispatch(intelligentbigdataActions.setSubjectFilterId([]));
    subjectData = [];
    for (let i = 0; i < limitMarkArray.length; i++) {
      limitMarkArray[i] = 0;
    }
    dispatch(intelligentbigdataActions.setLimitMarkArray(limitMarkArray));
    dispatch(intelligentbigdataActions.setLimitFilterId([]));
    limitData = [];
    for (let i = 0; i < levelMarkArray.length; i++) {
      levelMarkArray[i] = 0;
    }
    dispatch(intelligentbigdataActions.setLevelMarkArray(levelMarkArray));
    dispatch(intelligentbigdataActions.setLevelFilterId([]));
    levelData = [];
    for (let i = 0; i < tagMarkArray.length; i++) {
      tagMarkArray[i] = 0;
    }
    dispatch(intelligentbigdataActions.setTagMarkArray(tagMarkArray));
    dispatch(intelligentbigdataActions.setTagFilterId([]));
    tagData = [];
    for (let i = 0; i < propertyMarkArray.length; i++) {
      propertyMarkArray[i] = 0;
    }
    dispatch(intelligentbigdataActions.setPropertyMarkArray(propertyMarkArray));
    dispatch(intelligentbigdataActions.setPropertyFilterId([]));
    propertyData = [];
    for (let i = 0; i < provinceMarkArray.length; i++) {
      provinceMarkArray[i] = 0;
    }
    dispatch(intelligentbigdataActions.setProvinceMarkArray(provinceMarkArray));
    dispatch(intelligentbigdataActions.setProvinceFilterId([]));
    provinceData = [];
  };
}
const mapStateToProps = (state) => {
  return {
    schoolFilter: state.intelligentbigdata.schoolFilterData,
    markArray: state.intelligentbigdata.schoolMarkArrayData,
  };
};

export default connect(mapStateToProps)(IntelligentSchoolFilterGroup);



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataHome/components/IntelligentDataFilter/components/IntelligentSchoolFilterGroup/index.js